import { Injectable, inject } from '@angular/core';

import { Actions } from '@ngrx/effects';
import { Observable, of } from 'rxjs';
import { map, switchMap } from 'rxjs/operators';

import type { PaginationMeta } from '@core/http-types';
import { createEffectFactory } from '@core/ngrx-legacy';
import { JobBasic } from '@core/offers-types';

import { OffersByCompanyHttpService } from './offers-by-company-http.service';
import { OffersByCompanyActions } from './offers-by-company.store';

@Injectable({
  providedIn: 'root',
})
export class OffersByCompanyEffects {
  private readonly http = inject(OffersByCompanyHttpService);
  private readonly actions$ = inject(Actions);

  public effects = createEffectFactory(OffersByCompanyActions, this.actions$);

  public fetch = this.effects(OffersByCompanyActions.fetchOne, ({ payload }) =>
    this.fetchOneCollection(<string>payload.id, [], 1).pipe(
      map(response => ({
        data: response,
        id: response.id,
      })),
    ),
  );

  private fetchOneCollection(
    companyId: string,
    offers: JobBasic[],
    page: number,
  ): Observable<{ offers: JobBasic[]; id: string; meta?: PaginationMeta }> {
    return this.http.fetchOne$(companyId, page).pipe(
      switchMap(response => {
        const fetchedAll = response.meta
          ? response.meta.limit * response.meta.page > response.meta.totalCount
          : true;
        return fetchedAll
          ? of<{ offers: JobBasic[]; id: string; meta?: PaginationMeta }>({
              ...response,
              offers: [...offers, ...response.offers],
            })
          : this.fetchOneCollection(
              companyId,
              [...offers, ...response.offers],
              response.meta!.page + 1,
            );
      }),
    );
  }
}
